import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NumberdirectiveDirective } from './Directives/AllDirective.directive';
import { NgbCollapseModule, NgbDropdownModule, NgbModule, NgbNavModule, NgbProgressbarModule } from '@ng-bootstrap/ng-bootstrap';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { TextMaskDateDirective } from './Directives/text-mask-date.directive';
import { TooltipDirective } from './Directives/tooltip.directive';
import { CursorDirective } from '../theme/shared/directive/cursor.directive';

@NgModule({
  declarations: [
    NumberdirectiveDirective, TextMaskDateDirective, TooltipDirective, CursorDirective
  ],
  imports: [
    CommonModule,NgbDropdownModule,
    NgbNavModule,
    NgbModule,
    NgbCollapseModule,
    NgScrollbarModule,
    NgbProgressbarModule
  ],
  exports: [NumberdirectiveDirective, NgbDropdownModule,
    NgbNavModule,
    NgbModule,
    NgbCollapseModule,
    NgScrollbarModule,
    NgbProgressbarModule, TextMaskDateDirective, TooltipDirective, CursorDirective]
})
export class SharedModule { }
